"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOpportunityDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const opportunity_document_dto_1 = require("./opportunity-document.dto");
const opportunity_claim_experience_dto_1 = require("./opportunity-claim-experience.dto");
const opportunity_previous_placement_details_dto_1 = require("./opportunity-previous-placement-details.dto");
const opportunity_previous_mediator_details_dto_1 = require("./opportunity-previous-mediator-details.dto");
const opportunity_contact_map_dto_1 = require("./opportunity-contact-map.dto");
const opportunity_risk_locations_dto_1 = require("./opportunity-risk-locations.dto");
class CreateOpportunityDto {
    constructor(companyId, estimatedBrokerage, policyTypeLid, policyStatusLid, serviceLevelLid, soExpireDate, sumInsured, premiumPaid, estimatedFee, opportunityTypeLid, isPolicyMinedLid, source, opportunitySourceTypeLid) {
        this.companyId = companyId;
        this.estimatedBrokerage = estimatedBrokerage;
        this.policyTypeLid = policyTypeLid;
        this.policyStatusLid = policyStatusLid;
        this.serviceLevelLid = serviceLevelLid;
        this.soExpireDate = soExpireDate;
        this.sumInsured = sumInsured;
        this.premiumPaid = premiumPaid;
        this.estimatedFee = estimatedFee;
        this.opportunityTypeLid = opportunityTypeLid;
        this.isPolicyMinedLid = isPolicyMinedLid;
        this.source = source;
        this.opportunitySourceTypeLid = opportunitySourceTypeLid;
    }
}
exports.CreateOpportunityDto = CreateOpportunityDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company ID", example: 434 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Company ID is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Company ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Estimated brokerage", example: 1000 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Estimated brokerage must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "estimatedBrokerage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Policy type ID", example: 255 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy type is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Policy type ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "policyTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Policy status ID", example: 257 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy status is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Policy status ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "policyStatusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Service level ID", example: 259 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Service level is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Service level ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "serviceLevelLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "SO expire date in YYYY-MM-DD format",
        example: "2026-12-31",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "SO expire date is required" }),
    (0, class_validator_1.IsString)({ message: "SO expire date must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "SO expire date must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const date = new Date(value);
        if (date < new Date()) {
            throw new common_1.BadRequestException("SO expire date cannot be a past date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateOpportunityDto.prototype, "soExpireDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Sum insured", example: 500000 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Sum insured is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Sum insured must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Premium paid", example: 20000 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Premium paid must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "premiumPaid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Estimated fee", example: 500 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Estimated fee must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "estimatedFee", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Opportunity type ID",
        example: 312,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Opportunity type ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "opportunityTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Is policy mined ID",
        example: 310,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Is policy mined ID is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Is policy mined ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "isPolicyMinedLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Source Type ID",
        example: 303,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Source Type ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "opportunitySourceTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Source",
        example: "Some source",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Source must be a string" }),
    (0, class_validator_1.MaxLength)(255, { message: "Source must be atmost 255 characters" }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], CreateOpportunityDto.prototype, "source", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Sales pitch",
        example: "This is a sales pitch",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Sales pitch must be a string" }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], CreateOpportunityDto.prototype, "salesPitch", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityDto.prototype, "ownerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [opportunity_claim_experience_dto_1.OpportunityClaimExperienceDto],
        description: "List of opportunity claim experiences",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityDto.prototype, "claimExperiences", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [opportunity_document_dto_1.OpportunityDocumentDto],
        description: "List of opportunity documents",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [opportunity_risk_locations_dto_1.OpportunityRiskLocationDto],
        description: "List of opportunity risk locations",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Risk locations are required" }),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityDto.prototype, "riskLocations", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [opportunity_previous_placement_details_dto_1.OpportunityPreviousPlacementDetailsDto],
        description: "List of previous placement details",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityDto.prototype, "previousPlacementDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [opportunity_previous_mediator_details_dto_1.OpportunityPreviousMediatorDetailsDto],
        description: "List of opportunity previous mediator details",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityDto.prototype, "opportunityPreviousMediatorDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [opportunity_contact_map_dto_1.OpportunityContactMapDto],
        description: "List of contacts related to that company",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Contacts are required" }),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityDto.prototype, "contacts", void 0);
